<template>
  <div
    class="foot_nav_container"
    :style="(color ? 'color:' + color + ';' : '') + (absoult ? 'position: absolute;' : '') + myStyle"
  >
    <span @click="navigatorTo('')">电喵科技 © 2025 </span>
    <span @click="goWindow('https://beian.miit.gov.cn/')">苏ICP备18049487号-6</span>
    <span @click="navigatorTo('about')">最新资讯</span>
    <span>热线电话：400-8700-031</span>
  </div>
</template>
<script>
export default {
  props: ["color", "absoult", "myStyle"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goWindow(val) {
      window.open(val);
    },
    navigatorTo(val) {
      this.$router.push("/" + val);
    },
  },
};
</script>

<style lang="scss" scoped>
.foot_nav_container {
  // font-family: FangZhengHeiTi;
  font-weight: 600;
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  font-weight: bold;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 60px;
  left: 0;
  bottom: 0;
  background-color: #1c1c1c;

  span {
    margin: 0 12px;
    cursor: pointer;
  }

  span:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
}
</style>
